const instrumentCodesReducer = (state = [{code: "ALL", description: "All"}], action) => {
  switch (action.type) {
    case 'LANDLINK_INSTRUMENT_CODES':
      return action.results;
    default:
      break;
  }
  return state;
}

export default instrumentCodesReducer;